import { Component } from '@angular/core';

@Component({
    selector: 'app-sdec',
    templateUrl: './sdec.component.html',
    standalone: false
})
export class SdecComponent {}
